import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Lottie from 'react-lottie-player';
import { Alert, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row, Popover, PopoverBody } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import { googleLogout, useGoogleLogin } from '@react-oauth/google';

//redux
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// actions
import { loginUser, googleSsoLogin } from "../../store/actions";
import { useLocation } from 'react-router-dom';

const CommonIdentity = props => {

    //meta title
    document.title = "Login | Temperstack";

    const dispatch = useDispatch();

    const hostname = window.location.hostname;
    // get the domain
    const subdomain = hostname.split('.')[0];
    const domain = hostname.split('.').slice(1).join('.');
    const protocol = window.location.protocol;

    const isCommonLoginHost = subdomain === 'app';
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const next = searchParams.get('next');
    const client_subdomain = searchParams.get('client_subdomain');

    const googleLogin = useGoogleLogin({
        onSuccess: (codeResponse) => {
            let google_sso_data = {
                access_token: codeResponse.access_token,
                subdomain_name: client_subdomain,
                next_url: next
            }

            dispatch(googleSsoLogin(google_sso_data));
        },
        onError: (error) => console.log('Login Failed:', error)
    });

    useEffect(() => {
        if (isCommonLoginHost && client_subdomain) {

        } else {
            window.location.href = "https://app.temperstack.com";
        }
    }, [isCommonLoginHost, client_subdomain]);

    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    return (
        <React.Fragment>
            <div className="my-3 pt-sm-3"
                 style={{display: "flex", justifyContent: "flex-start", height: "100vh"}}>
                <Container fluid>
                    <Row className="justify-content-center why-bluejay">
                        <Col lg={12}>
                            <Card className="overflow-hidden mt-4">
                                <CardBody className="">
                                {isCommonLoginHost && client_subdomain ? (
                                        <>
                                            <h1 style={{textAlign: "center"}}>Authenticate with your SSO Identity Provider</h1>
                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                <button className="btn btn-primary w-md mt-2" onClick={() => googleLogin()}>
                                                    Sign in With Google
                                                </button>
                                            </div>
                                        </>
                                ) : (
                                    <h1 style={{textAlign: "center"}}>Redirecting to app.temperstack.com...</h1>
                                )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(CommonIdentity);

CommonIdentity.propTypes = {
    history: PropTypes.object,
};
